import React from 'react';
import './Solutions.css';

const SOLUTIONS = [
  {
    icon: '🎯',
    title: 'Events & Engagement',
    desc: 'Create powerful platforms for interaction, knowledge exchange, and influence.',
    items: [
      'Conferences & Leadership Summits',
      'Roundtables & Expert Forums',
      'Workshops & Scientific Sessions',
      'Webinars & Knowledge Series',
    ],
  },
  {
    icon: '💡',
    title: 'Special Products & Solutions',
    desc: 'Custom-built marketing solutions to support brand growth and lifecycle management.',
    items: [
      'Medical Content & Scientific Communication',
      'Campaign Strategy & Execution',
      'KOL Engagement & Advocacy',
      'AI-enabled Smart Collateral',
      'Gamification & Engagement Programs',
      'Multimedia & Video Campaigns',
    ],
  },
];

function Solutions() {
  return (
    <section id="solutions" className="section-padding">
      <div className="container">
        <h2 className="section-title reveal">Our Solutions</h2>

        <div className="solutions__grid">
          {SOLUTIONS.map(({ icon, title, desc, items }) => (
            <div className="solutions__card reveal" key={title}>
              <div className="solutions__icon">{icon}</div>
              <h3 className="solutions__card-title">{title}</h3>
              <p>{desc}</p>
              <ul className="solutions__list">
                {items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Solutions;
